import { memo, useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { getColor } from 'basic-components';
import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import { CommonService } from 'dashboard-services/services';
import { DropdownService } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import properties from 'resources/constants/properties.json';

import MetadataLabel from 'primary/MetadataLabel';

import KeyFilterBody from '../KeyFilterBody';

import { useQueryClient } from '@tanstack/react-query';

const getGroupName = value => {
  if(value?.groupName) {
    return value.groupName
  }
  if(CommonService.isJson(value)) {
    const parsed = JSON.parse(value)
    return parsed?.groupName || undefined
  }
  return value;
}

const EMPTY_ARRAY = [];
const EMPTY_OBJ = {};
const MetadataKey = ({
  dependsOnParam = EMPTY_OBJ,
  ref,
  ...props
}) => {
  const dispatch = useDispatch(),
        [keyQuery, setKeyQuery] = useState(),
        queryClient = useQueryClient(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        groupName = useMemo(() => getGroupName(dependsOnParam?.value || dependsOnParam?.defaultValue), [dependsOnParam]),
        { fetchNextPage: fetchMoreMetadataKeys, isFetching: isFetchingKeys, isFetchingNextPage: isFetchingNextPageKeys, data: keysFromApiRaw = EMPTY_ARRAY } = DropdownService.useQueryMetadata({
          queryClient,
          input: keyQuery,
          groupName,
          useEs: properties.useEsSymbolListing === "true",
          getApiConfig: getApiConfigLocal,
          metadata: true
        }),
        keysFromApi = useMemo(() => (keysFromApiRaw || []).map(item => ({ 
          value: item.value, 
          label: item.type === DataStorageEnums.KEY_TYPE.METADATA ? (<MetadataLabel name={item.value}/>) : item.value,
          color: item.type === DataStorageEnums.KEY_TYPE.METADATA ? getColor("grey-dark") : undefined,
          type: item.type 
        })), [keysFromApiRaw])

  return (
    <KeyFilterBody
        {...props}
        fetchMoreKeys={fetchMoreMetadataKeys}
        groupName={groupName}
        isFetchingKeys={isFetchingKeys}
        isFetchingNextPageKeys={isFetchingNextPageKeys}
        keysFromApi={keysFromApi}
        ref={ref}
        setKeyQuery={setKeyQuery}
    />
  )
}

MetadataKey.displayName = "MetadataKey"

MetadataKey.propTypes = {
  dependsOnParam: PropTypes.object, 
}

export default memo(MetadataKey);
